import { render } from "./belowtarget.vue?vue&type=template&id=de67b67e"
import script from "./belowtarget.vue?vue&type=script&lang=js"
export * from "./belowtarget.vue?vue&type=script&lang=js"

import "./belowtarget.vue?vue&type=style&index=0&id=de67b67e&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__